const objectHas = (obj: unknown, key: string): boolean => Object.prototype.hasOwnProperty.call(obj, key);

export default objectHas;
